import { render, staticRenderFns } from "./AddScholarshipView.vue?vue&type=template&id=d4fe4cde&scoped=true&"
import script from "./AddScholarshipView.vue?vue&type=script&lang=js&"
export * from "./AddScholarshipView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fe4cde",
  null
  
)

export default component.exports